import { render } from "./Persandian.vue?vue&type=template&id=6893ca9b"
import script from "./Persandian.vue?vue&type=script&lang=js"
export * from "./Persandian.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__